import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let DriversAdApiPromise: Promise<AxiosInstance> | null = null;

const getDriversAdApi = async (): Promise<AxiosInstance | null> => {
  if (DriversAdApiPromise) return DriversAdApiPromise;
  DriversAdApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return DriversAdApiPromise;
};

export interface ActiveDirectoryDriverUser {
  id: string;
  displayName: string;
  givenName: string;
  surname: string;
  userPrincipalName: string;
  mail: string;
}

export interface GetDriversActiveDirectoryUsersProps {
  busqueda?: string;
}

export const getDriversActiveDirectoryUsers = async (
  props: GetDriversActiveDirectoryUsersProps,
): Promise<ActiveDirectoryDriverUser[] | null> => {
  const api = await getDriversAdApi();
  if (!api) return null;

  const qs = objectToQueryStringWithArray(props);
  const url = qs
    ? `/Choferes/GetListadoChoferesAD?${qs}`
    : "/Choferes/GetListadoChoferesAD";

  const response = await api.get(url);
  return response.data;
};
